<template>
  <div class="accountMembers">
    <h2>Add Member to Account</h2>
    <!-- TODO: CMS messaging add members -->
    <p><strong>Your membership covers you and one other person. Your spouse, life partner or children living at home under the age of 21.</strong></p>
    <form v-on:submit.prevent="clickAddMember">
      <div class="form-group row">
        <label class="col-sm-4 col-form-label">New Member Given Name</label>
        <input
          v-model="newMember.given_name"
          v-validate="'required'"
          name="Given Name"
          type="text"
          placeholder="Given Name"
          class="col-sm-8 form-control"
        >
        <div class="invalid-feedback">{{errors.first('Given Name')}}</div>

        <label class="col-sm-4 col-form-label">New Member Family Name</label>
        <input
          v-model="newMember.family_name"
          v-validate="'required'"
          name="Family Name"
          type="text"
          placeholder="Family Name"
          class="col-sm-8 form-control"
        >
        <div class="invalid-feedback">{{errors.first('Family Name')}}</div>

        <label class="col-sm-4 col-form-label">New Member Email</label>
        <!-- |notExists'" -->
        <input
          v-model="newMember.email"
          v-validate="'required|email'"
          name="Email"
          type="text"
          placeholder="newmember@cherrytree.co.nz"
          class="col-sm-8 form-control"
        >
        <div class="invalid-feedback">{{errors.first('Email')}}</div>

        <div class="invalid-feedback">
          {{errorMessages}}
        </div>

        <ButtonWithLoading
          v-if="membersOnAccount < accountCountLimit"
          class="btn btn-primary mx-auto"
          type="submit"
          text="Add Member"
          loadingText="Adding Member"
          successText="Member Added"
          failureText="Error Adding Member"
          :state="addMemberState"
        />
      </div>
    </form>
  </div>
</template>

<script>
import { addMember } from "@/network/userRequests";
import ButtonWithLoading from "@/components/buttonWithLoading";
import {mapState} from 'vuex'
//import { Validator } from "vee-validate";

export default {
  name: "AddMember",
  data: () => {
    return {
      newMember: {},
      addMemberState: null,
      errorMessage: 0
    };
  },
  components: {
    ButtonWithLoading
  },
  mounted() {
    // const userExists = email =>
    //   new Promise(resolve => {
    //     fetchUserExists({ email }, exists => {
    //       if (!exists) {
    //         return resolve({ valid: true }); //user doesn't exist, field is valid
    //       } else {
    //         return resolve({
    //           valid: false,
    //           data: { message: `${email} is already a member. Please contact Cherrytree on 0800 243 779 to invite ${email} to be added to your membership and any points they have to be added to your joint account.` } //error message
    //         });
    //       }
    //     });
    //   });
    //
    // Validator.extend("notExists", {
    //   validate: userExists,
    //   getMessage: (field, params, data) => data.message
    // });
  },
  computed:{
    ...mapState({
      membersOnAccount: state => state.auth.account_count
    }),
    accountCountLimit(){
      return 2
    },
    errorMessages(){
      if(this.errorMessage == 1){
        return `We cannot add `+this.newMember.email+` to your membership as you have reached the maximum of `+this.accountCountLimit+` people allowed on your membership.`
      } else if(this.errorMessage == 2){
        return `We cannot add `+this.newMember.email+` to your membership as they are already a Cherrytree Member. They have been sent an email notifying them that you would like to add them to your membership.`
      }
      return ``
    }
  },
  methods: {
    clickAddMember() {
      this.$validator.validateAll().then(valid => {
        //console.log("valid ", valid);
        if (!valid) return;
        this.addMemberState = "loading";
        const memberDetails = {
          email: this.newMember.email,
          given_name: this.newMember.given_name,
          family_name: this.newMember.family_name
        };
        addMember(memberDetails, (success) => {
          this.errorMessage = success.return_code
          if(success.return_code == 1){
            this.addMemberState = "failure"
            setTimeout(() => {
              this.addMemberState = null;
              //this.newMember = {}; //reset new member form
              this.$validator.reset(); //reset validations
            }, 2000);
          } else if (success.return_code == 2){
            this.addMemberState = "failure"
            setTimeout(() => {
              this.addMemberState = null;
              //this.newMember = {}; //reset new member form
              this.$validator.reset(); //reset validations
            }, 2000);
          } else if (success.return_code == 0){
            this.addMemberState = "success";
            this.$gtm.trackEvent({
              event: "addMember"
            })
            setTimeout(() => {
              this.addMemberState = null;
              this.newMember = {}; //reset new member form
              this.$validator.reset(); //reset validations
            }, 2000);
          }
          //console.log(success);
        }, (err)=>{
          console.log(err)
        });
      });
    }
  }
};
</script>

<style lang="scss" scoped>
</style>
